import {
  ElegibilidadeSeguro,
  RecorteVinculosEncerrados,
  StatusEncerradoBucket,
} from "@/models/consignado/proposal-billings.model";

// Filtro rápido de "Vínculos Encerrados": "TODOS" + os buckets que a rota
// classifica (HIS-ADM-cobranca-029). Vai pra API como `recorte`.
export type StatusFiltroEncerrado = "TODOS" | StatusEncerradoBucket;

export const STATUS_ENCERRADO_LABEL: Record<StatusEncerradoBucket, string> = {
  SEM_SEGURO: "Sem seguro",
  NAO_ELEGIVEL: "Não elegível ao seguro",
  EM_FRANQUIA: "Em franquia · VE < 30 dias",
  ELEGIVEL_PARCIAL_MAIS_30_MAIOR_500: "Elegível parcial · Parcela > R$ 500 · VE ≥ 30 dias",
  ELEGIVEL_MAIS_30_MENOR_500: "100% Elegível · Parcela ≤ R$ 500 · VE ≥ 30 dias",
};

export const recorteDoStatusFiltroEncerrado = (status: StatusFiltroEncerrado): RecorteVinculosEncerrados =>
  status.toLowerCase() as RecorteVinculosEncerrados;

export const ELEGIBILIDADE_LABEL: Record<NonNullable<ElegibilidadeSeguro>, string> = {
  sem_seguro: STATUS_ENCERRADO_LABEL.SEM_SEGURO,
  nao_elegivel: STATUS_ENCERRADO_LABEL.NAO_ELEGIVEL,
  em_franquia: STATUS_ENCERRADO_LABEL.EM_FRANQUIA,
  elegivel_parcial_mais_30_maior_500: STATUS_ENCERRADO_LABEL.ELEGIVEL_PARCIAL_MAIS_30_MAIOR_500,
  elegivel_mais_30_menor_500: STATUS_ENCERRADO_LABEL.ELEGIVEL_MAIS_30_MENOR_500,
};
